import { create, multicast, never, merge, of, Observable } from 'agos';

// persists obsevable data and propagate the currently persisted upon open
export const persists = observable => {
  let current;
  let isset = false;

  const single = multicast(observable);

  return create((open, next, fail, done, talkback) => {
    single.listen(
      () => {
        if (isset) {
          next(current);
        }
      },
      data => {
        current = data;
        if (! isset) {
          isset = true;
        }
        next(current);
      },
      fail,
      () => {},
      talkback
    );

    open();
    if (isset) {
      next(current);
    }
  });
};

export const fromEvent = (target, name, options) =>
  create((open, next, fail, done, talkback) => {
    open();
    target.addEventListener(name, next, options);
    talkback.listen(
      () => {},
      payload => {
        if (payload[ 0 ] === Observable.CANCEL) {
          target.removeEventListener(name, next);
          done(true);
        }
      },
      () => {},
      () => {},
      never()
    );
  });

export const onDocumentVisibilityChange = merge([fromEvent(document, 'visibilitychange', false), of()]);
